import 'intersection-observer'

export default {
  data () {
    return {
      ioAnimation: null
    }
  },
  beforeDestroy () {
    if (this.ioAnimation) {
      this.setAnimationDestroy()
    }
  },
  mounted () {
    this.setAnimation()
  },
  methods: {
    onAnimation: function (entries, observer) {
      entries.forEach(({
                         target,
                         isIntersecting
                       }, index) => {
        // 가시성의 변화가 있으면 관찰 대상 전체에 대한 콜백이 실행되므로,
        // 관찰 대상의 교차 상태가 false일(보이지 않는) 경우 실행하지 않음.

        if (!isIntersecting) {
          // console.log('up')
          target.classList.add('hidden')
        } else {
          // 관찰 대상의 교차 상태가 true일(보이는) 경우 실행.
          // console.log('down')
          setTimeout(function () {
            target.classList.remove('hidden')
          }, index * 200)

          // 위 실행을 처리하고(1회) 관찰 중지
          // observer.unobserve(target)
        }
      })
    },
    setAnimation: function () {
      this.ioAnimation = new IntersectionObserver(this.onAnimation, {
        rootMargin: '100px 0px -100px 0px'
      })
      document.querySelectorAll('.animation').forEach(v => {
        this.ioAnimation.observe(v)
      })
    },
    setAnimationDestroy: function () {
      if (this.ioAnimation) {
        this.ioAnimation.disconnect()
        this.ioAnimation = null
      }
    }
  }
}
